import { createAppRoot } from './app/bootstrap/createAppRoot';

createAppRoot({ shell: 'default' });
